import Asset from "./Asset";
import IAsset from "./IAsset";
import { ACLResourceType } from "./ACLResourceType";

export default abstract class WideoAsset extends Asset implements IAsset {
    public getACLResourceType = (): ACLResourceType => {
        throw new Error("Not implemented for WideoAsset");
    }
}


// WEBPACK FOOTER //
// src/opt/atlassian/pipelines/agent/build/src/api/model/WideoAsset.ts